export default __webpack_public_path__ + "7b142b1fc78526eca32a6d324ed96bc7.png";